import {
  Dialog,
  DialogContent,
  DialogTitle,
  ErrorOutlineOutlinedIcon,
  Flex,
  Text,
} from '@shared/components';

interface TaskOverdueNoticeModalProps {
  open: boolean;
  onClose: () => void;
}

export default function TaskOverdueNoticeModal(props: Readonly<TaskOverdueNoticeModalProps>) {
  const { open: isOpen, onClose } = props;
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth='md' onClick={(e) => e.stopPropagation()}>
      <DialogTitle onClose={onClose}>Overdue</DialogTitle>
      <DialogContent
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: theme.spacing(4),
        })}
      >
        <ErrorOutlineOutlinedIcon
          sx={(theme) => ({ color: theme.palette.error.main, fontSize: 100 })}
        />
        <Flex
          sx={(theme) => ({
            flexDirection: 'column',
            gap: theme.spacing(2),
            alignItems: 'center',
            pb: theme.spacing(15),
          })}
        >
          <Text variant='h3'>ไม่สามารถ Start Task ได้</Text>
          <Text>เนื่องจากเลยวันที่กำหนดส่ง กรุณาติดต่อผู้มอบหมายงาน</Text>
        </Flex>
      </DialogContent>
    </Dialog>
  );
}
